export const FEATURE_KEYS = {
  DUBBING: 'dubbing',
  RECAPTCHA_TRY_LISTEN_TTS_TYPE: 'recaptcha-try-listen-tts-type',
  RECAPTCHA_TTS_TYPE: 'recaptcha-tts-type',
  TRY_LISTEN_TTS: 'try-listen-tts',
  OLD_AUTO_SAVE_DRAFT: 'old-auto-save-draft',
  AUTO_SAVE_DRAFT_MOBILE: 'auto-save-draft-mobile',
  OLD_REQUEST_TABLE: 'old-request-table',
  DOWNLOAD_AUDIO_LINK: 'download-audio-link',
  NEW_PLAY_AUDIO_LINK: 'new-play-audio-link',
  NEW_EDITOR: 'new-editor',
  NEW_EFFECT_GUIDE: 'new-effect-guide',
  HIGHLIGHT_TO_PREVIEW: 'highlight-to-preview',
  NEW_PAYMENT_PACKAGES: 'new-payment-packages',
  NEW_SIDEBAR: 'new-sidebar',
  SIDEBAR_VOUCHER: 'sidebar-voucher',
  NEW_PAYMENT: 'new-payment',
  NEW_TTS_UI: 'new-tts-ui', // new UI for user include: new sidebar, new editor, audio player
  NEW_PACKAGE_PRICE_UI: 'new-package-price-ui',
  AUTO_RENEWAL_PAYMENT: 'auto-renewal-payment',
  CONFIG_AUTO_RENEW_PREPAID_PACKAGE: 'config-auto-renew-prepaid-package',
  SUBSCRIPTION: 'subscription',
  DUBBING_BY_UNIT_SECOND: 'dubbing-by-unit-second',
  SEPARATE_AIVOICE_PRODUCTS: 'separate-aivoice-products',
  NEW_DUBBING: 'new-dubbing',
  SHOW_PACKAGE_DURATION: 'show-package-duration',
  LIXI_2024: 'lixi-2024',
  MULTIPLE_INPUT_DUBBING: 'multiple-input-dubbing',
  DISCOUNT_FOR_FIRST_PAID_USER: 'discount-for-first-paid-user',
  GOOGLE_ONE_TAP: 'google-one-tap',
  VOICE_CLONING: 'voice-cloning',
  VOICE_CLONING_HOMEPAGE: 'voice-cloning-homepage',
  LIMIT_DOWNLOAD_FREE_PACKAGE: 'limit-download-free-package',
  NEW_DUBBING_UI: 'new-dubbing-ui',
  NEW_LIST_PACKAGE_UI: 'new-list-package-ui',
  STREAMING_PREVIEW: 'streaming-preview',
  USE_FREE_PACKAGE: 'use-free-package',
  USE_FREE_PACKAGE_V2: 'use-free-package-v2',
  USE_FREE_PACKAGE_V3: 'use-free-package-v3',
  NEW_AUTO_SELECT_VOUCHER: 'new-auto-select-voucher',
  HOME_PAGE: 'home-page',
  DUBBING_PACKAGE_GIFT: 'dubbing-package-gift',
  DUBBING_SUBTITLE_TIMELINE: 'dubbing-subtitle-timeline',
  NEW_UPLOAD: 'new-upload-file-link', // New upload file and new import link
  DUBBING_MULTIPLE_VOICES: 'dubbing-multiple-voices',
  NEW_TOURGUIDE_TTS: 'new-tourguide-tts', // New tourguide for TTS
  UPLOAD_FILE_PDF: 'upload-file-pdf', // Upload file pdf for TTS
  NEW_SUPPORT_UI: 'new-support-ui', // New UI support
  NEW_FOLOW_PAYMENT_UI: 'new-flow-payment-ui', // New flow payment UI
  AUTO_RENEW_MOMO: 'auto-renew-momo', // Use auto-renew with momo
  GIVEAWAY_TRIAL_DUBBING_PACKAGE: 'giveaway-trial-dubbing-package', // New flow add trial dubbing
  NEW_VOUCHER_BANNER: 'new-voucher-banner',
  DUBBING_PROJECTS: 'dubbing-projects',
  REDIRECT_VOUCHER_LINK: 'redirect-voucher-link',
  MULTIPLE_LANGUAGES_SRT: 'multiple-languages-srt',
  VIEW_VIDEO_WITH_TIMELINE: 'view-video-with-timeline',
  STT: 'stt',
  USE_PRESERVATION_EXPIRY_DATE: 'use-preservation-expiry-date',
  NEW_BANK_TRANSFER: 'new-bank-transfer',
  NEW_PREVIEW_BUTTON: 'new-preview-button',
  NEW_DOWNLOAD_BUTTON: 'new-download-button',
  NEW_TOOLBAR: 'new-toolbar',
  DATASENSES: 'datasenses',
  HEADER_BANNER_FLASH_SALE: 'header-banner-flash-sale',
  NEW_SSO_STUDIO: 'new-sso-studio',
  FAKE_END_TIME_VOUCHER: 'fake-time-voucher',
  NEW_LEGAL: 'new-legal',
  MIGRATE_FREE_PLAN: 'migrate-free-plan',
  NEW_NAVIGATION_DUBBING: 'new-navigation-dubbing',
  NEW_PROFILE_MOBILE: 'new-profile-mobile',
  NEW_SIDEBAR_MOBILE: 'new-sidebar-mobile',
  NEW_SIDEBAR_DESKTOP: 'new-sidebar-desktop',
  NEW_HEADER_MOBILE: 'new-header-mobile',
  DEFAULT_BANK: 'default-bank',
  SAMPLE_SCRIPTS: 'sample-scripts',
  VOUCHER_BY_PRODUCT: 'voucher-by-product',
  NEW_WARNING_BUY_PACKAGE: 'new-warning-buy-package',
  ALLOW_CREATE_CLONING_VOICE: 'allow-create-cloning-voice',
  TITLE_PRODUCT: 'title-product',
  MOBILE_UI: 'mobile-ui',
  NEW_PACKAGE_MOBILE: 'new-package-mobile',
  AUTO_RENEW_ONLY_MONTHLY_PACKAGE: 'auto-renew-only-monthly-package',
  NEW_SIDEBAR_V2: 'new-sidebar-v2', // this use to move package info in avatar to the top right (sprint 33)
  NEW_TTS_LAYOUT: 'new-tts-layout',
  NEW_LAYOUT_PAYMENT_METHOD: 'new-layout-payment-method',
  BLOCK_SPAM_EMAIL: 'block-spam-email',
  NEW_REQUESTS_LAYOUT: 'new-requests-layout',
  PANEL_RESIZE_LAYOUT: 'panel-resize-layout',
  NEW_GLOBAL_ORDER: 'new-global-order',
  AUTO_PLAY_REQUEST: 'auto-play-request',
  INFINITE_SCROLL_REQUESTS: 'infinite-scroll-requests',
  PHONE_COUNTRY_INPUT: 'phone-country-input',
  VC_NEW_RECORDING: 'vc-new-recording',
  NEW_MANAGE_DEVICE: 'new-manage-device',
  LOADING_LOAD_REQUEST: 'loading-load-request',
  NEW_PACKAGES_TAB: 'new-packages-tab',
  NEW_DICTIONARY_UI: 'new-dictionary-ui',
  NEW_PAGINATION: 'new-pagination',
  PREVIEW_ON_MOBILE_WEB: 'preview-on-mobile-web',
  CUSTOM_READING_METHOD: 'new-reading-method',
  ICON_NEW_DICTIONARY: 'icon-new-dictionary',
  AUDIO_EFFECT_MOBILE_WEB: 'audio-effect-mobile-web',
  NEW_POPUP_CHOOSE_VOICE: 'new-popup-choose-voice',
  BANNER_HOMEPAGE: 'banner-homepage',
  DICTIONARY_GUIDE: 'dictionary-guide',
  CUSTOM_SPEED_INPUT: 'custom-speed-input',
  SUGGEST_DICTIONARY: 'suggest-dictionary',
  NEW_HOMEPAGE: 'new-homepage',
  NEW_VOICES_LIST: 'new-voices-list',
  NEW_PRODUCTS_LIST: 'new-products-list',
  BREAK_TIME_MOBILE_WEB: 'break-time-mobile-web',
  READ_DICTIONARY: 'read-dictionary',
  NEW_HOMEPAGE_REQUEST: 'new-homepage-request',
  RESIZE_TTS_MOBILE: 'resize-tts-mobile',
  PUSH_EVENT_VIEW_PRICING: 'push-event-view-pricing',
  NEW_UX_SYNTHESIS: 'new-ux-synthesis',
  RENAME_MERGE_PRODUCT: 'rename-merge-product',
  NEW_HATE_SPEECH_DETECTOR: 'new-hate-speech-detector',
  NON_VBEE_CREDITS_FACTOR: 'non-vbee-credits-factor',
  VOICE_CREDITS_BY_LEVEL: 'voice-credits-by-level',
  NEW_SUBSCRIPTION_ITEM: 'new-subscription-item',
  NEW_PRICING_MODEL: 'new-pricing-model',
  PROMOTED_PACKAGE_MOE: 'promoted-package-moe',
  BLOCK_DUBBING_PAYMENT: 'block-dubbing-payment',
  SHOW_MULTIPLE_PACKAGES_INFO: 'show-multiple-packages-info',
  SYNC_AFFILIATE_MARKETER: 'sync-affiliate-marketer',
  SENTRY_AIVOICE_WEB_APP: 'sentry-aivoice-web-app',
  NEW_PRICE_VOUCHER: 'new-price-voucher',
  PERMATE_TRACKING: 'permate-tracking',
  SHOW_BLACK_WORDS_ON_MOBILE: 'show-black-words-on-mobile',
  VOICE_CLONING_AUTOMATED_TRAINING: 'voice-cloning-automated-training',
  NEW_DUBBING_REQUESTS_LIST: 'new-dubbing-requests-list',
  AMAZON_VOICE_SPEED_CONTROL: 'amazon-voice-speed-control',
  NON_VBEE_BREAK_TIME: 'non-vbee-break-time',
  AI_EDITTING: 'ai-editing',
  PERCENT_DISCOUNT_PAYMENT: 'percent-discount-payment',
  NEW_HEADER_UI: 'new-header-ui',
  INTRODUCE_NEW_MOBILE_APP: 'introduce-new-mobile-app',
  VNPAY_DISCOUNT_INFO: 'vnpay-discount-info',
  MULTILINGUAL_VOICE: 'multilingual-voice',
  NEW_QR_FLOW: 'new-qr-flow',
  NEW_PRICING_MODEL_V3: 'new-pricing-model-v3',
  USE_USAGE_OPTIONS_IN_PACKAGE: 'use-usage-options-in-package',
  UI_BUY_TOP_UP_CHARACTERS: 'ui-buy-top-up-characters',
  PACKAGE_INFO_V3: 'package-info-v3', // this for v3 pricing model
  PAYMENT_QR_V2: 'payment-qr-v2',
  NEW_MY_PACKAGE: 'new-my-package',
  ROUNDED_TOTAL_PRICE: 'rounded-total-price',
  MIGRATE_OLD_PKG_TO_V3: 'migrate-old-pkg-to-v3',
  SHOW_POPUP_MIGRATE_V3: 'show-popup-migrate-v3',
  REFUND_PRICE_CURRENT_PLAN: 'refund-price-current-plan',
  LOCK_CYCLE_CREDITS: 'lock-cycle-credits',
  LOCK_TOP_UP_CREDITS: 'lock-top-up-credits',
  VOICE_SELECTION_NOTICE: 'voice-selection-notice',
  LIMIT_CREATE_VOICE_CLONING: 'limit-create-voice-cloning',
  LOCK_ONE_TIME_CREDITS_ADVANCED_VOICE: 'lock-one-time-credits-advanced-voice',
  USE_MIN_PAYMENT_METHOD_AMOUNT: 'use-min-payment-method-amount',
  SIGNUP_SURVEY: 'signup-survey',
  PROJECT: 'project',
  VALIDATE_VOICE_CLONING_ON_PLAN_CHANGE:
    'validate-voice-cloning-on-plan-change',
  LOCK_CUSTOM_CREDITS: 'lock-custom-credits',
  NEW_CONTACT_SUPPORT: 'new-contact-support',
  UPDATE_VOICES_BY_USER_EOL_DATE: 'update-voices-by-user-eol-date',
  VOUCHER_FOR_AUTO_RENEW: 'voucher-for-auto-renew',
  VOICE_HAS_BEEN_RENAMED: 'voice-has-been-renamed',
};
